import { useState, useCallback, useEffect } from "react";
import { useRouter } from "next/router";
import Cookies from "js-cookie";

import Button from "../Button";
import Text from "../Text";
import CloseIcon from "../Icons/Close";

function BuildBanner() {
  const [build, setBuild] = useState<string | undefined>();
  const {
    query: { hideBuildBanner },
  } = useRouter();

  useEffect(() => {
    const build = Cookies.get("build");
    setBuild(build);
  }, []);

  const hideBanner = useCallback(() => {
    setBuild(undefined);
  }, []);

  const resetBuild = useCallback(() => {
    Cookies.remove("build");
    // reload the page without query params
    window.location.href = window.location.pathname;
  }, []);

  if (!build || hideBuildBanner) {
    return null;
  }

  return (
    <div className="relative px-6 py-4 bg-lapel">
      <Text as="p" className="text-center text-white paragraph-small">
        Build: {build}
      </Text>
      <div className="absolute inset-y-0 right-0 flex items-center pr-2 space-x-2">
        <button
          type="button"
          onClick={resetBuild}
          className="paragraph-small text-white"
        >
          Clear build
        </button>
        <button type="button" onClick={hideBanner}>
          <CloseIcon width="1.25rem" height="1.25rem" />
        </button>
      </div>
    </div>
  );
}

export default BuildBanner;
